const rankingItems = [
  { title: '星际征途2：新纪元', type: '电影', views: '128万', tag: 'HOT', rank: 1 },
  { title: '暗夜追踪', type: '电视剧', views: '96万', tag: 'NEW', rank: 2 },
  { title: '时光旅人 第三季', type: '电视剧', views: '85万', tag: 'HOT', rank: 3 },
  { title: '深海迷踪', type: '电影', views: '72万', tag: '', rank: 4 },
  { title: '都市夜话', type: '电视剧', views: '68万', tag: 'HOT', rank: 5 },
  { title: '荒野求生记', type: '纪录片', views: '55万', tag: 'NEW', rank: 6 },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              本周最受欢迎的高清影视内容排行
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-50 transition-colors cursor-pointer group`}
              >
                <div className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-300 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
                      {item.title}
                    </span>
                    {item.tag && (
                      <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                        item.tag === 'HOT'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-primary-100 text-primary-700'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-500">{item.type}</span>
                </div>

                <div className="flex items-center gap-1 text-xs md:text-sm text-foreground-500">
                  <i className="ri-eye-line text-xs"></i>
                  <span className="whitespace-nowrap">{item.views}次</span>
                </div>

                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg text-foreground-400 group-hover:text-accent-500 group-hover:bg-accent-50 transition-all cursor-pointer">
                  <i className="ri-play-fill text-base md:text-lg ml-0.5"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}